<template>
    <footer class="b-bar border-top" name="bottom-bar">
        
      <div class="d-flex align-items-center justify-content-center w-100 h-100">            
        <slot></slot>          
      </div>          

    </footer>
</template>

<script>
export default {
    name:"BottomNavBar"
}
</script>

<style lang="css" scoped>
  @import "./style.css";
</style>
